(function () {
  if (window.productGridMetaRowsLoaded) return;

  window.productGridMetaRowsLoaded = true;

  function alignProductCardMetaRows() {
    const scopes = document.querySelectorAll('#product-grid, .product-recommendations__section, .grid-of-products__container');

    scopes.forEach((scope) => {
      const cards = Array.from(scope.querySelectorAll('.product-card, .product-card__section-grid'));
      if (!cards.length) return;

      cards.forEach((card) => {
        card.classList.remove('product-card--tags-two-lines', 'product-card--collections-two-lines');
      });

      const rows = new Map();

      cards.forEach((card) => {
        const rowKey = Math.round(card.getBoundingClientRect().top);

        if (!rows.has(rowKey)) {
          rows.set(rowKey, []);
        }

        rows.get(rowKey).push(card);
      });

      rows.forEach((rowCards) => {
        const tagsNeedTwoLines = rowCards.some((card) => {
          const tags = card.querySelector('.product-card__info-tags');
          return tags && tags.scrollWidth > tags.clientWidth + 1;
        });
        const collectionsNeedTwoLines = rowCards.some((card) => {
          const collections = card.querySelector('.product-card__collection-meta');
          return collections && collections.scrollWidth > collections.clientWidth + 1;
        });

        rowCards.forEach((card) => {
          if (tagsNeedTwoLines) {
            card.classList.add('product-card--tags-two-lines');
          }

          if (collectionsNeedTwoLines) {
            card.classList.add('product-card--collections-two-lines');
          }
        });
      });
    });
  }

  let productCardMetaRowsTimer;

  function scheduleProductCardMetaRowsAlignment() {
    clearTimeout(productCardMetaRowsTimer);
    productCardMetaRowsTimer = setTimeout(alignProductCardMetaRows, 80);
  }

  function buildSectionUrl(url, sectionId) {
    const nextUrl = new URL(url, window.location.origin);
    nextUrl.searchParams.set('section_id', sectionId);
    return nextUrl.toString();
  }

  function loadMoreProducts(event) {
    const link = event.target.closest('[data-product-grid-load-more]');
    if (!link) return;

    const grid = document.getElementById('product-grid');
    const productGridContainer = document.getElementById('ProductGridContainer');
    if (!grid || !productGridContainer) return;

    event.preventDefault();

    const wrapper = link.closest('.product-grid-load-more-wrapper');
    const label = link.querySelector('span:last-child');
    const originalLabel = label ? label.textContent : '';

    link.classList.add('is-loading');
    link.setAttribute('aria-busy', 'true');
    if (label) label.textContent = 'Caricamento...';

    fetch(buildSectionUrl(link.href, grid.dataset.id))
      .then((response) => response.text())
      .then((responseText) => {
        const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
        const nextGrid = parsedHTML.getElementById('product-grid');
        const nextWrapper = parsedHTML.querySelector('.product-grid-load-more-wrapper');

        if (nextGrid) {
          Array.from(nextGrid.children).forEach((item) => grid.appendChild(item));
        }

        if (nextWrapper && wrapper) {
          wrapper.replaceWith(nextWrapper);
        } else if (wrapper) {
          wrapper.remove();
        }

        scheduleProductCardMetaRowsAlignment();
      })
      .catch(() => {
        link.classList.remove('is-loading');
        link.removeAttribute('aria-busy');
        if (label) label.textContent = originalLabel;
      });
  }

  document.addEventListener('DOMContentLoaded', scheduleProductCardMetaRowsAlignment);
  document.addEventListener('click', loadMoreProducts);
  window.addEventListener('load', scheduleProductCardMetaRowsAlignment);
  window.addEventListener('resize', scheduleProductCardMetaRowsAlignment);

  document.addEventListener('shopify:section:load', scheduleProductCardMetaRowsAlignment);
  document.addEventListener('shopify:section:select', scheduleProductCardMetaRowsAlignment);

  if (window.MutationObserver) {
    const productCardMetaRowsObserver = new MutationObserver(scheduleProductCardMetaRowsAlignment);

    document.addEventListener('DOMContentLoaded', () => {
      productCardMetaRowsObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  }
})();
